import axios from 'axios';
/**
 * Reduces a multi-dimensional array into a single array list.
 * @param data
 */
export const flattenArr = function (data) {
  return data.reduce((r, e) => (Array.isArray(e) ? r = r.concat(flattenArr(e)) : r.push(e) && r), []);
  // data.reduce((r, e) => r.concat(Array.isArray(e) ? flattenArr(e) : [e]), [])
};

export const removeDuplicated = function (arr, key = 'id') {
  if (arr) {
    const map = new Map();
    arr.map((el) => {
      if (!map.has(el.data[key])) {
        map.set(el.data[key], el);
      }
    });
    return [...map.values()];
  }
};

/**
 * merge obj key array values.
 * @param {*} obj
 */
export const mergeArrayFromObj = (obj) => {
  let results = [];
  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      results = results.concat(value);
    }
  });
  return results;
};

/**
 * @param array
 * @returns {*}
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

/**
 *
 * @param {object} state
 */
export const formatSelect2State = (state) => {
  if (!state.id) {
    return state.text;
  }
  const baseUrl = '/wb/images/icons/badges';
  const $state = $(
    `<img src="${baseUrl}/${state.title.toLowerCase()}.png" class="mp-img-badge" />`,
  );
  return $state;
};

export const replaceSpecicalCharacter = (filename) => {
  filename = filename.replace(/[^a-zA-Z0-9\.\_\-\,\s]/g, '_');
  filename = filename.replace(/__+/g, '_');
  return filename;
};

/**
 * Re
 * @param {string} key
 * @param {string} filename
 */
export const replaceS3Key = (key, filename) => {
  key = key.replace(/\$\{filename\}/g, replaceSpcicalCharacter(filename));
  return key;
};


export const s3FileUploadService = async (auth, file) => {
  const data = JSON.stringify({ authVal: auth });
  axios.get(`${wbConfig.baseUrl}/workboard/GetS3Data`, data).then((resp) => {
    const fd = new FormData();
    const key = replaceS3Key(resp.key, file.name);
    const fileName = replaceSpecicalCharacter(file.name);
    fd.append('acl', 'public-read');
    fd.append('key', key);
    fd.append('policy', resp.policy);
    fd.append('success_action_status', 201);
    fd.append('Filename', fileName);
    fd.append('Content-type', file.type);
    fd.append('AWSAccessKeyId', resp.keyId);
    fd.append('signature', resp.signature);
    fd.append('file', file);
  });
};
